module.exports = __webpack_public_path__ + "img/quanjinditu.799386ac.png";